import React, { useState,useEffect,useRef } from 'react';
import Button,{
    buttonTypes,
    buttonSizes,
    buttonTextSizes,
} from '../shared/Button';
import '../../scss/partials/assignDevices/assignDevices.css';
import LoadingSpinner from '../shared/LoadingSpinner';
import { connect } from 'react-redux';
import SvgXIcon from '../svg/XIcon';
import ReactPaginate from 'react-paginate';
import { FormattedMessage } from 'react-intl';
import HelpIcon from '../shared/HelpIcon';
import InlineHelpText from '../shared/InlineHelpText';
import SvgDownArrowIcon from '../svg/DownArrowIcon';
import SvgUpArrowIcon from '../svg/UpArrowIcon';
import { makeDeviceAssignmentRequest,
    clearPostConflictDevices,
    clearPostConflictDevicesForConflictUsers } from '../../redux/actions/assignDevicesActions';
import UnmatchedDevicesList from './UnmatchedDevices';
import ConflictAssignments from './ConflictAssignments';

export function UnConnectedSuggestion(props){
  const { alarmDeviceTypes,
    summary, 
    unMatched, 
    valueAssignTo, 
    apiSpinner, 
    handleClose, 
    postConflict, 
    postConflictUserConflict
  } = props;

  const[view, setView]= useState("summary");

  function compareType(a, b){
    return a.alarm_device_type - b.alarm_device_type;
  }

  let sortedDevices = [];

  useEffect(()=>{
    let displayArr=[];
    let conflictsArr=[];
    summary.forEach((u)=>{
        let matchdevices = [...u.alarm_devices];
        // sort alarm devices based on alarm device type
        matchdevices.sort(compareType);

        let category=[];
        let devices=[];
        let type = matchdevices[0].alarm_device_type;
        let totalSpanLength = 0;
        //group alarm devices based on alarm device type
        for(let i=0;i<matchdevices.length;i++){
          if(matchdevices[i].alarm_device_type === type){
              devices.push({deviceid:matchdevices[i].alarm_device_id,
                deviceDesc:matchdevices[i].alarm_description})
          }
          else{
              totalSpanLength += devices.length;
              category.push({categoryid:type,
                cateDesc:alarmDeviceTypes[type].description,
                matchdevices:[...devices],
                matchLength:devices.length});
              type = matchdevices[i].alarm_device_type;
              devices = [];
              devices.push({deviceid:matchdevices[i].alarm_device_id,
                deviceDesc:matchdevices[i].alarm_description})
          }    
        }
        totalSpanLength += devices.length;
        category.push({categoryid:type,
          cateDesc:alarmDeviceTypes[type].description,
          matchdevices:[...devices],
          matchLength:devices.length});

        if(valueAssignTo === "units"){
          sortedDevices.push({unitid:u.unit_id,
            unitDesc:u.unit_name,
            category:category,
            spanLength:totalSpanLength});
        }
        else if(valueAssignTo === "users"){
          sortedDevices.push({userid:u.user_id,
            firstName:u.first_name,
            lastName:u.last_name,
            activeUnit:u.unit_name,
            category:category,
            spanLength:totalSpanLength,
            conflicted:u.has_conflict
          });
        }

    });

    //added checked attribute to handle selection
    sortedDevices.forEach((u) =>{
      const newCategory=[];
      
      u.category.forEach((eachCat)=>{
        const newMatchDevices=[];
        eachCat.matchdevices.forEach((eachdevice) =>{
          newMatchDevices.push({...eachdevice,
            checked:true});//by default checkbox should be checked so set to true   
        });
        newCategory.push({...eachCat,matchdevices:newMatchDevices});
      });
      displayArr.push({...u,category:newCategory});
    });

    if(valueAssignTo === "users"){
      //filtering conflicted users to display in conflicts tab
      conflictsArr = displayArr.filter(user => user.conflicted === true);
      displayArr = displayArr.filter(user => user.conflicted === false);
      //checked and disable attribute for selection and disable
      conflictsArr.forEach(d => {
        d.category.forEach((c) => {
          c.matchdevices.forEach((eachdevice) => {
            eachdevice.checked = false;
            eachdevice.disable = false;
          });
        });
      });
    }
    
    setCheckArr([...displayArr]);
    setConflictingDevicesArr([...conflictsArr]);

  },[summary])// eslint-disable-line

    const [unMatchedDevicesArr, setUnMatchedDevicesArr] = useState([]);
    const [conflictingDevicesArr, setConflictingDevicesArr] = useState([]);

    useEffect(()=>{
      if(unMatched.length >0){
        let unmatcheddevices = [...unMatched];
        // sort alarm devices based on alarm device type
        unmatcheddevices.sort(compareType);
        let category=[];
        let matchdevices=[];
        let type = unmatcheddevices[0].alarm_device_type;
        //group alarm devices based on alarm device type
        for(let i=0;i<unmatcheddevices.length;i++){
          if(unmatcheddevices[i].alarm_device_type === type){
            matchdevices.push({deviceid:unmatcheddevices[i].alarm_device_id,
              deviceDesc:unmatcheddevices[i].alarm_description})
          }
          else{
            category.push({cateDesc:alarmDeviceTypes[type].description,
              matchdevices:[...matchdevices],
              matchLength:matchdevices.length});
            type = unmatcheddevices[i].alarm_device_type;
            matchdevices = [];
            matchdevices.push({deviceid:unmatcheddevices[i].alarm_device_id,
              deviceDesc:unmatcheddevices[i].alarm_description})
          }
        }
        category.push({cateDesc:alarmDeviceTypes[type].description,
          matchdevices:[...matchdevices],
          matchLength:matchdevices.length});

        setUnMatchedDevicesArr([...category]);
    }
  },[unMatched])// eslint-disable-line

    let sortParamSet = valueAssignTo === "units" ? "unitDesc" : "firstName";

    const [tableSort, setTableSort] = useState({
      sortParam: sortParamSet,
      sortOrder: 'az',
    });

    function setSortType(param) {
      const value = param;
      let sortOrder = tableSort.sortOrder;
      if (value === tableSort.sortParam) {
        if (tableSort.sortOrder === 'az') {
          sortOrder = 'za';
        } else {
          sortOrder = 'az';
        }
      }
      setTableSort({
        ...tableSort,
        sortParam: value,
        sortOrder: sortOrder,
      });
    }

    function dataCategorySort(data){
      data.forEach((u)=>{
        u.category = dataSort(u.category);
      });
      return data;
    }

    function dataDeviceSort(data){
      data.forEach((u)=>{
        u.category.forEach((c)=>{
          c.matchdevices = dataSort(c.matchdevices);
        });
      });
      return data;
    }

    function dataSort(data) {
      function checkIfLetters(value) {
        const regex = RegExp('^d');
        return regex.test(value);
      }
      let sortedData;
      const sortParam = tableSort.sortParam;
  
      if (tableSort.sortOrder === 'az') {
        sortedData = data.sort(function (a, b) {
          let aParam = a[sortParam];
          let bParam = b[sortParam];
          if (typeof aParam === 'string') {
            aParam = aParam.trim();
          }
          if (typeof bParam === 'string') {
            bParam = bParam.trim();
          }
          const aIsLetters = checkIfLetters(aParam);
          const bIsLetters = checkIfLetters(bParam);
          if (typeof aParam === 'string' && aIsLetters && bIsLetters) {
            aParam = aParam.toUpperCase();
            bParam = bParam.toUpperCase(); 
          }
  
          if (aParam < bParam) {
            return -1;
          }
          if (aParam > bParam) {
            return 1;
          }
          return 0;
        });
      } else if (tableSort.sortOrder === 'za') {
        sortedData = data.sort(function (a, b) {
          let aParam = a[sortParam];
          let bParam = b[sortParam];
          if (typeof aParam === 'string') {
            aParam = aParam.trim();
          }
          if (typeof bParam === 'string') {
            bParam = bParam.trim();
          }
          const aIsLetters = checkIfLetters(aParam);
          const bIsLetters = checkIfLetters(bParam);
          if (typeof aParam === 'string' && aIsLetters && bIsLetters) {
            aParam = aParam.toUpperCase();
            bParam = bParam.toUpperCase(); 
          }
  
          if (aParam < bParam) {
            return 1;
          }
          if (aParam > bParam) {
            return -1;
          }
          return 0;
        });
      }
      return sortedData;
    }

    const [showCheckBoxHelpText, setShowCheckBoxHelpText] = useState(false);
    const checkBoxHelpTextRef = useRef();

    function toggleCheckBoxHelpText(value) {
      setShowCheckBoxHelpText(value);
    }

    const checkBoxHelpText = (
    <FormattedMessage
      id="assignDevicesSuggestion.checkBoxHelpText"
      defaultMessage="UnCheck respective checkbox if any of the assignment is not needed/incorrect"
      description="Help text."
    />);

    const [currentPage, setCurrentPage] = useState(0);

    const [pagerParams, setPagerParams] = useState({
        totalLength: 0,
        startValue: 0,
        endValue: 10,
        incrementValue: 10,
        totalPages:0,
      });

    const [searchFilter, setSearchFilter] = useState('');
    const handleSearchFilter = (event) => {
        const value = event.target.value;
        const pagerValues = { ...pagerParams };
        pagerValues.startValue = 0;
        setCurrentPage(0);
        setSearchFilter(value);
      };
    
    function handlePageChange({selected}){
      const pagerValues = {...pagerParams};
      let total = pagerValues.totalLength;
      let startTemp = selected * pagerParams.incrementValue;
      let endTemp = startTemp + pagerParams.incrementValue > total ? total : startTemp + pagerParams.incrementValue;
      pagerValues.startValue = startTemp;
      pagerValues.endValue = endTemp;
      setCurrentPage(selected);
      setPagerParams(pagerValues);
    }  

    //to determine if atleast one of the checkbox is checked
    //to enable assign button
    function anyChecked(){
      let condition = checkArr.some((u) =>{
        return u.category.some((c)=>{
           return c.matchdevices.some((d)=> d.checked);
        });
    });
    return condition;
    }

    function handleChange(id, categoryindex, deviceindex){

      let tempArr = [...checkArr];
      //to find index of user or unit based on id 
      let uindex = tempArr.map( (u) => {
        if( valueAssignTo === "units"){
          return u.unitid
        }
        if( valueAssignTo === "users"){
          return u.userid
        }} ).indexOf(id);
      //toggling checkbox based on array index reference
      tempArr[uindex].category[categoryindex]
      .matchdevices[deviceindex].checked = !(tempArr[uindex].category[categoryindex]
                                            .matchdevices[deviceindex].checked);
      
      let option = tempArr[uindex].category[categoryindex].matchdevices[deviceindex].checked;
      
      //check if every checkbox of devices is checked to check all checkbox
      let condition = tempArr.every((u) =>{
          return u.category.every((c)=>{
              return c.matchdevices.every((d)=> d.checked);
          });
      });

      if(condition){
          setAllChecked(true);
      }
      //if any of checkbox is unchecked then all checkbox should also unchecked
      if(option === false && allChecked){
          setAllChecked(false);
      }
      setCheckArr([...tempArr]);
    }

    const [allChecked, setAllChecked] = useState(true);
    
    function handleAllChange(){

      //to toggle all device checkboxes if checkbox of all is toggled
      let tempArr = [...checkArr];
      let chk = !(allChecked);
      setAllChecked(chk);
      tempArr.forEach((u)=>{
          u.category.forEach((c)=>{
              c.matchdevices.forEach((d)=>{
                  d.checked = chk;
              });
          });
      });
      setCheckArr([...tempArr]);
    }

    function onClose(){
      //clearing post conflict data if any on closing summary popup
      handleClose();
      if(postConflict.length > 0)
      props.dispatch(clearPostConflictDevices());
      if(postConflictUserConflict.length > 0)
      props.dispatch(clearPostConflictDevicesForConflictUsers());
    }

    const [assignmentTriggered, setAssignmentTriggered] = useState(false);
    const [conflictAssignmentTriggered, setConflictAssignmentTriggered] = useState(false);
    const [postSummaryData, setPostSummaryData] = useState({});
    const [postCategoryReference, setPostCategoryReference] = useState({});

    function handleAssign(){
      setAssignmentTriggered(true);
      // category reference to be used when post error occurs
      let categoryReference = {};
      //copy of the posted devices
      let postDeviceAssignmentData = [];

      //iterate to get the checked devices to post
      //also store copy of the posted devices in postDeviceAssignmentData
      checkArr.forEach((u)=>{
        let categorytemp = [];
        let matchid = [];
        u.category.forEach((c)=>{  
          let matchdevices = [];
          c.matchdevices.forEach((d) => {
            if(d.checked){
              categoryReference[d.deviceid]={deviceDesc:d.deviceDesc,
                cateid:c.categoryid,cateDesc:c.cateDesc};
              matchid.push(d.deviceid);
              matchdevices.push({deviceid:d.deviceid,deviceDesc:d.deviceDesc});
            }
          });

          if(matchdevices.length > 0){
          categorytemp.push({cateDesc:c.cateDesc,
            matchdevices:matchdevices,matchLength:matchdevices.length});
          }
        });
        
        if(valueAssignTo === "units"){
          if(matchid.length > 0){
            postDeviceAssignmentData.push({unit_id:u.unitid,alarm_devices:matchid});
            postSummaryData[u.unitid] = {
              unitid:u.unitid,
              unitDesc:u.unitDesc,
              category:categorytemp,
              spanLength:categorytemp.length};
          }
        }
        else if(valueAssignTo === "users"){
          if(matchid.length > 0){
            postDeviceAssignmentData.push({user_id:u.userid,alarm_devices:matchid});
            postSummaryData[u.userid] = {
              userid:u.userid,
              firstName:u.firstName,
              lastName:u.lastName,
              category:categorytemp,
              spanLength:categorytemp.length};
          }
        }
      });
      props.dispatch(makeDeviceAssignmentRequest({assignTo:valueAssignTo,
        data:postDeviceAssignmentData}));
      setPostSummaryData({...postSummaryData});
      setPostCategoryReference({...categoryReference});
    }

    const [checkArr, setCheckArr] = useState([]);

    function conflictingDevices(){
      return(
        <div>
          {conflictingDevicesArr.length > 0 ? (
          <ConflictAssignments data={conflictingDevicesArr}
            assignmentTriggeredFlag={conflictAssignmentTriggered}
            setAssignmentTriggeredFlag={setConflictAssignmentTriggered}/>) : 
            (<div className="width-100">
            <p className="text-medium item-container__main-text center-text">
              {"No Conflicting Assignments present"}</p>
          </div>)
          }
        </div>
      );
    }

    function unMatchedDevices(){
      return(
        <div>
          {unMatchedDevicesArr ? <UnmatchedDevicesList data={unMatchedDevicesArr}/> : 
          (<div className="width-100">
            <p className="text-medium item-container__main-text center-text">All devices matched</p>
          </div>)}
        </div>
      );
    }

    //function to display user assignment summary
    function displayUsersTable(tabledata){
      return(
        <table className="tabletag width-100" data-test="assignmentSummary-table">
          <thead>
            <tr>
              <td className="table_head_row text-bold" data-test="table-head">
              {<Button onClick={() => setSortType("firstName")}
                  text={"First Name"}
                  rightIcon={ tableSort.sortParam === "firstName" ? 
                  (tableSort.sortOrder === 'az' ? <SvgUpArrowIcon /> : <SvgDownArrowIcon />) : ""}
                  buttonType={buttonTypes.noButton}
                  buttonSize={buttonSizes.small}
                  data-test="sort-button"
                  buttonStyle={
                    'text-medium ' +
                    (tableSort.sortOrder === "firstName"
                      ? 'no-margin text-extra-bold text-very-light-grey'
                      : 'no-margin text-regular text-white')}/>
              }
              </td>
              <td className="table_head_row text-bold" data-test="table-head">
              {<Button onClick={() => setSortType("lastName")}
                  text={"Last Name"}
                  rightIcon={ tableSort.sortParam === "lastName" ? 
                  (tableSort.sortOrder === 'az' ? <SvgUpArrowIcon /> : <SvgDownArrowIcon />) : ""}
                  buttonType={buttonTypes.noButton}
                  buttonSize={buttonSizes.small}
                  data-test="sort-button"
                  buttonStyle={
                    'text-medium ' +
                    (tableSort.sortOrder === "lastName"
                      ? 'no-margin text-extra-bold text-very-light-grey'
                      : 'no-margin text-regular text-white')}/>
              }
              </td>
              <td className="table_head_row text-bold" data-test="table-head">
              {<Button onClick={() => setSortType("cateDesc")}
                  text={"Category"}
                  rightIcon={ tableSort.sortParam === "cateDesc" ? 
                  (tableSort.sortOrder === 'az' ? <SvgUpArrowIcon /> : <SvgDownArrowIcon />) : ""}
                  buttonType={buttonTypes.noButton}
                  buttonSize={buttonSizes.small}
                  data-test="sort-button"
                  buttonStyle={
                      'text-medium ' +
                      (tableSort.sortOrder === "cateDesc"
                        ? 'no-margin text-extra-bold text-very-light-grey'
                        : 'no-margin text-regular text-white')
                  }/>}
              </td>
              <td className="table_head_row text-bold" data-test="table-head">
              {<Button
                    onClick={() => setSortType("deviceDesc")}
                    text={"Device Description"}
                    rightIcon={ tableSort.sortParam === "deviceDesc" ? 
                    (tableSort.sortOrder === 'az' ? <SvgUpArrowIcon /> : <SvgDownArrowIcon />) : ""}
                    buttonType={buttonTypes.noButton}
                    buttonSize={buttonSizes.small}
                    data-test="sort-button"
                    buttonStyle={
                      'text-medium ' +
                      (tableSort.sortOrder === "deviceDesc"
                        ? 'no-margin text-extra-bold text-very-light-grey'
                        : 'no-margin text-regular text-white')
                    }
               />}
              </td>
              <td className="table_head_row text-bold">
              <input type="checkbox" onClick={()=>handleAllChange()} 
                checked={allChecked}></input>
              <HelpIcon onClick={() => checkBoxHelpTextRef.current.toggleHelpText()}
                        toggled={showCheckBoxHelpText}
                        styles="margin-left-20 helpp-icon"/>
              </td>
            </tr>
          </thead>
          <tbody>
          {tabledata.map((each, index) =>{
            return(<React.Fragment>
              <tr data-test="table-row">
                <td rowSpan={each.spanLength} 
                  className={ index % 2 ? 
                    "table__row table__row--alternate align-top": 
                    "table__row align-top"}>{each.firstName}</td>
                <td rowSpan={each.spanLength}
                  className={ index % 2 ? 
                    "table__row table__row--alternate align-top": 
                    "table__row align-top"}>{each.lastName}</td>
                <td rowSpan={each.category[0].matchLength} 
                  className={ index % 2 ? 
                  "table__row table__row--alternate align-top": 
                  "table__row align-top"}>{each.category[0].cateDesc}</td>
                <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                  {each.category[0].matchdevices[0].deviceDesc}</td>
                <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                  <input type="checkbox" onClick={()=>handleChange(each.userid,0,0)} 
                  checked={each.category[0].matchdevices[0].checked}></input>
                </td>
              </tr>
              {each.category[0].matchdevices.map((match, deviceindex)=>{
                if(deviceindex === 0){
                  return ''
                }
                return(<React.Fragment>
                  <tr>
                    <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                      {match.deviceDesc}</td>
                    <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                      <input type="checkbox" onClick={()=>handleChange(each.userid,0,deviceindex)} 
                      checked={match.checked}></input>
                    </td>
                  </tr>
                </React.Fragment>);
              })}
              {each.category.map((eachCatt, catindex)=>{
                if(catindex === 0){
                  return ''
                }
                return(<React.Fragment>
                  <tr>
                    <td rowSpan={eachCatt.matchLength} 
                    className={index % 2 ? "table__row table__row--alternate align-top": "table__row align-top"}>
                      {eachCatt.cateDesc}</td>
                    <td className={index % 2 ? "table__row table__row--alternate": "table__row"}>
                      {eachCatt.matchdevices[0].deviceDesc}</td>
                    <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                      <input type="checkbox" onClick={()=>handleChange(each.userid,catindex,0)} 
                      checked={eachCatt.matchdevices[0].checked}></input>
                    </td>
                  </tr>
                  {eachCatt.matchdevices.map((match, deviceindex)=>{
                    if(deviceindex === 0)
                      return '';
                    return(<React.Fragment>
                      <tr>
                        <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                          {match.deviceDesc}</td>
                        <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                          <input type="checkbox" 
                            onClick={()=>handleChange(each.userid,catindex,deviceindex)} 
                          checked={match.checked}></input>
                        </td>
                      </tr>
                    </React.Fragment>);
                  })}
                </React.Fragment>);
              })}
            </React.Fragment>);
          })}
          </tbody>
        </table>
      );
    }
    
    //function to display devices that are returned by post conflict
    function displayUnitPostConflict(){
      let tableTempData=[];
      //only get device id's from response so add device description and alarm device type 
      //using category referece arr
      postConflict.forEach((u)=> {
        let alarm_devices = [];
        u.alarm_devices.forEach(d =>{
          alarm_devices.push({
            deviceid:d,
            deviceDesc:postCategoryReference[d].deviceDesc,
            deviceType:postCategoryReference[d].cateid
          })
        });
        tableTempData.push({
          unitid:u.unit_id,
          unitName:postSummaryData[u.unit_id].unitDesc,
          alarm_devices:[...alarm_devices]
        });
      });

      let tableData = [];
      tableTempData.forEach((u)=>{
        let matchdevices = [...u.alarm_devices];
        // sort alarm devices based on alarm device type
        matchdevices.sort(compareType);
        let category=[];
        let devices=[];
        let type = matchdevices[0].deviceType;
        let totalSpanLength = 0;
        //group alarm devices based on alarm device type
        for(let i=0;i<matchdevices.length;i++){
          if(matchdevices[i].deviceType === type){
              devices.push({deviceid:matchdevices[i].deviceid,
                deviceDesc:matchdevices[i].deviceDesc})
          }
          else{
              totalSpanLength += devices.length;
              category.push({
                categoryid:type,
                cateDesc:alarmDeviceTypes[type].description,
                matchdevices:[...devices],
                matchLength:devices.length});
              type = matchdevices[i].deviceType;
              devices = [];
              devices.push({deviceid:matchdevices[i].deviceid,
                deviceDesc:matchdevices[i].deviceDesc})
          }
        }
        totalSpanLength += devices.length;
        category.push({
          categoryid:type,
          cateDesc:alarmDeviceTypes[type].description,
          matchdevices:[...devices],
          matchLength:devices.length});
        tableData.push({unitid:u.unitid,
            unitDesc:u.unitName,
            category:category,
            spanLength:totalSpanLength});

    });

    return(
      <React.Fragment>
      <div className="width-100">
        <p className="text-medium item-container__main-text center-text">
          {"Error Occurred while assigning the following devices"}</p>
      </div>
      <table className="tabletag width-100" data-test="assignmentSummary-table">
        <thead>
          <tr>
            <td className="table_head_row text-bold" data-test="table-head">{"Unit Description"}</td>
            <td className="table_head_row text-bold" data-test="table-head">{"Category"}</td>
            <td className="table_head_row text-bold" data-test="table-head">{"Device Description"}</td>
          </tr>
        </thead>
        <tbody>
          {tableData.map((each, index) =>{
            return(<React.Fragment>
              <tr data-test="table-row">
                  <td rowSpan={each.spanLength} 
                  className={ index % 2 ? "table__row table__row--alternate align-top": "table__row align-top"}>
                    {each.unitDesc}</td>
                  <td rowSpan={each.category[0].matchLength} 
                  className={ index % 2 ? "table__row table__row--alternate align-top": "table__row align-top"}>
                    {each.category[0].cateDesc}</td>
                  <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                    {each.category[0].matchdevices[0].deviceDesc}</td>
              </tr>
              {each.category[0].matchdevices.map((match, deviceindex)=>{
                if(deviceindex === 0){
                  return '';
                }
                return(<React.Fragment>
                  <tr>
                    <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                      {match.deviceDesc}</td>
                  </tr>
                </React.Fragment>);
              })}
              {each.category.map((eachCatt, catindex)=>{
                if(catindex === 0){
                  return '';
                }
                return(<React.Fragment>
                  <tr>
                    <td rowSpan={eachCatt.matchLength} 
                    className={index % 2 ? "table__row table__row--alternate align-top": "table__row align-top"}>
                      {eachCatt.cateDesc}</td>
                    <td className={index % 2 ? "table__row table__row--alternate": "table__row"}>
                      {eachCatt.matchdevices[0].deviceDesc}</td>
                  </tr>
                  {eachCatt.matchdevices.map((match, deviceindex)=>{
                    if(deviceindex === 0)
                      return '';
                    return(<React.Fragment>
                      <tr>
                        <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                          {match.deviceDesc}</td>
                      </tr>
                    </React.Fragment>);
                  })}
                </React.Fragment>);
              })}
              </React.Fragment>);
            })}
        </tbody>
      </table>
      </React.Fragment>
    );
    }

    //function to display assignment summary table for unit
    function displayUnitsTable(tabledata){
      return(
        <table className="tabletag width-100" data-test="assignmentSummary-table">
          <thead>
            <tr>
              <td className="table_head_row text-bold" data-test="table-head">
              {<Button
                  onClick={() => setSortType("unitDesc")}
                  text={"Unit Description"}
                  rightIcon={ tableSort.sortParam === "unitDesc" ? 
                  (tableSort.sortOrder === 'az' ? <SvgUpArrowIcon /> : <SvgDownArrowIcon />) : ""}
                  buttonType={buttonTypes.noButton}
                  buttonSize={buttonSizes.small}
                  data-test="sort-button"
                  buttonStyle={
                    'text-medium ' +
                    (tableSort.sortOrder === "unitDesc"
                      ? 'no-margin text-extra-bold text-very-light-grey'
                      : 'no-margin text-regular text-white')
                  }
              />}
              </td>
              <td className="table_head_row text-bold" data-test="table-head">
              {<Button
                  onClick={() => setSortType("cateDesc")}
                  text={"Category"}
                  rightIcon={ tableSort.sortParam === "cateDesc" ? 
                  (tableSort.sortOrder === 'az' ? <SvgUpArrowIcon /> : <SvgDownArrowIcon />) : ""}
                  buttonType={buttonTypes.noButton}
                  buttonSize={buttonSizes.small}
                  data-test="sort-button"
                  buttonStyle={
                    'text-medium ' +
                    (tableSort.sortOrder === "cateDesc"
                      ? 'no-margin text-extra-bold text-very-light-grey'
                      : 'no-margin text-regular text-white')
                  }/>
              }
              </td>
              <td className="table_head_row text-bold" data-test="table-head">
              {<Button
                  onClick={() => setSortType("deviceDesc")}
                  text={"Device Description"}
                  rightIcon={ tableSort.sortParam === "deviceDesc" ?
                  (tableSort.sortOrder === 'az' ? <SvgUpArrowIcon /> : <SvgDownArrowIcon />) : ""}
                  buttonType={buttonTypes.noButton}
                  buttonSize={buttonSizes.small}
                  data-test="sort-button"
                  buttonStyle={
                    'text-medium ' +
                    (tableSort.sortOrder === "deviceDesc"
                      ? 'no-margin text-extra-bold text-very-light-grey'
                      : 'no-margin text-regular text-white')
                  }/>
              }
              </td>
              <td className="table_head_row text-bold">
              <input type="checkbox" onClick={()=>handleAllChange()} 
                                                    checked={allChecked}></input>
              <HelpIcon onClick={() => checkBoxHelpTextRef.current.toggleHelpText()}
                        toggled={showCheckBoxHelpText}
                        styles="margin-left-20 helpp-icon"/>
              </td>
            </tr>
          </thead>
          <tbody>
          {tabledata.map((each, index) =>{
            return(<React.Fragment>
              <tr data-test="table-row">
                  <td rowSpan={each.spanLength}
                    className={ index % 2 ? 
                      ("table__row table__row--alternate align-top"):
                      ("table__row align-top")}>
                    {each.unitDesc}</td>
                  <td rowSpan={each.category[0].matchLength} 
                    className={ index % 2 ? 
                      "table__row table__row--alternate align-top": 
                      "table__row align-top"}>
                  {each.category[0].cateDesc}</td>
                  <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                    {each.category[0].matchdevices[0].deviceDesc}</td>
                  <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                    <input type="checkbox" onClick={()=>handleChange(each.unitid,0,0)} 
                    checked={each.category[0].matchdevices[0].checked}></input>
                  </td>
              </tr>
              {each.category[0].matchdevices.map((match, deviceindex)=>{
                if(deviceindex === 0){
                  return '';
                }
                return(<React.Fragment>
                  <tr>
                    <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                      {match.deviceDesc}</td>
                    <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                      <input type="checkbox" onClick={()=>handleChange(each.unitid,0,deviceindex)} 
                      checked={match.checked}></input>
                    </td>
                  </tr>
                </React.Fragment>);
              })}
              {each.category.map((eachCatt, catindex)=>{
                if(catindex === 0){
                  return '';
                }
                return(<React.Fragment>
                  <tr>
                    <td rowSpan={eachCatt.matchLength} 
                      className={index % 2 ? 
                        "table__row table__row--alternate align-top":
                        "table__row align-top"}>
                      {eachCatt.cateDesc}</td>
                    <td className={index % 2 ? "table__row table__row--alternate": "table__row"}>
                      {eachCatt.matchdevices[0].deviceDesc}</td>
                    <td className={index % 2 ? "table__row table__row--alternate": "table__row"}>
                      <input type="checkbox" onClick={()=>handleChange(each.unitid,catindex,0)} 
                      checked={eachCatt.matchdevices[0].checked}></input>
                    </td>
                  </tr>
                  {eachCatt.matchdevices.map((match, deviceindex)=>{
                    if(deviceindex === 0)
                      return '';
                    return(<React.Fragment>
                      <tr>
                        <td className={ index % 2 ? 
                          "table__row table__row--alternate": 
                          "table__row"}>
                        {match.deviceDesc}</td>
                        <td className={ index % 2 ? 
                          "table__row table__row--alternate": 
                          "table__row"}>
                        <input type="checkbox" onClick={()=>handleChange(each.unitid,catindex,deviceindex)} 
                          checked={match.checked}></input>
                        </td>
                      </tr>
                    </React.Fragment>);
                  })}
                </React.Fragment>);
              })}
              </React.Fragment>);
            })}
          </tbody>
        </table>
      );
    }

    //function to display conflict devices returned by post
    function displayUserPostConflict(){

      let tableTempData=[];
      //only get device id's from response so add device description and alarm device type 
      //using category referece arr
      postConflict.forEach((u)=> {
        let alarm_devices = [];
        u.alarm_devices.forEach(d =>{
          alarm_devices.push({deviceid:d,
            deviceDesc:postCategoryReference[d].deviceDesc,
            deviceType:postCategoryReference[d].cateid})
        });
        tableTempData.push({userid:u.user_id,
        firstName:postSummaryData[u.user_id].firstName,
        lastName:postSummaryData[u.user_id].lastName,
        alarm_devices:[...alarm_devices]});
      });

      let tableData = [];
      tableTempData.forEach((u)=>{
        let matchdevices = [...u.alarm_devices];
        // sort alarm devices based on alarm device type
        matchdevices.sort(compareType);
        let category=[];
        let devices=[];
        let type = matchdevices[0].deviceType;
        let totalSpanLength = 0;
        //group alarm devices based on alarm device type
        for(let i=0;i<matchdevices.length;i++){
          if(matchdevices[i].deviceType === type){
            devices.push({deviceid:matchdevices[i].deviceid,
              deviceDesc:matchdevices[i].deviceDesc})
          }
          else{
            totalSpanLength += devices.length;
            category.push({
              categoryid:type,
              cateDesc:alarmDeviceTypes[type].description,
              matchdevices:[...devices],
              matchLength:devices.length
            });
            type = matchdevices[i].deviceType;
            devices = [];
            devices.push({deviceid:matchdevices[i].deviceid,
              deviceDesc:matchdevices[i].deviceDesc})
          }  
        }
        totalSpanLength += devices.length;
        category.push({
          categoryid:type,
          cateDesc:alarmDeviceTypes[type].description,
          matchdevices:[...devices],
          matchLength:devices.length});
        tableData.push({userid:u.userid,
              firstName:u.firstName,
              lastName:u.lastName,
              category:category,
              spanLength:totalSpanLength,
            });
    });

      return(
        <React.Fragment>
        <div className="width-100">
          <p className="text-medium item-container__main-text center-text">
            {"Error Occurred while assigning the following devices"}</p>
        </div>
        <table className="tabletag width-100" data-test="assignmentSummary-table">
          <thead>
            <tr>
              <td className="table_head_row text-bold" data-test="table-head">{"First Name"}</td>
              <td className="table_head_row text-bold" data-test="table-head">{"Last Name"}</td>
              <td className="table_head_row text-bold" data-test="table-head">{"Category"}</td>
              <td className="table_head_row text-bold" data-test="table-head">
                {"Device Description"}</td>
            </tr>
          </thead>
          <tbody>
          {tableData.map((each, index) =>{
            return(<React.Fragment>
              <tr data-test="table-row">
                <td rowSpan={each.spanLength} 
                  className={ index % 2 ? 
                    "table__row table__row--alternate align-top": 
                    "table__row align-top"}>
                {each.firstName}</td>
                <td rowSpan={each.spanLength} 
                  className={ index % 2 ? 
                    "table__row table__row--alternate align-top": 
                    "table__row align-top"}>
                {each.lastName}</td>
                <td rowSpan={each.category[0].matchLength} 
                  className={ index % 2 ? 
                  "table__row table__row--alternate align-top": 
                  "table__row align-top"}>
                {each.category[0].cateDesc}</td>
                <td className={ index % 2 ? 
                  "table__row table__row--alternate": 
                  "table__row"}>
                {each.category[0].matchdevices[0].deviceDesc}</td>
              </tr>
              {each.category[0].matchdevices.map((match, deviceindex)=>{
                if(deviceindex === 0){
                  return ''
                }
                return(<React.Fragment>
                  <tr>
                    <td className={ index % 2 ? "table__row table__row--alternate": "table__row"}>
                      {match.deviceDesc}</td>
                  </tr>
                </React.Fragment>);
              })}
              {each.category.map((eachCatt, catindex)=>{
                if(catindex === 0){
                  return ''
                }
                return(<React.Fragment>
                  <tr>
                    <td rowSpan={eachCatt.matchLength} 
                      className={index % 2 ? 
                      "table__row table__row--alternate align-top": 
                      "table__row align-top"}>
                    {eachCatt.cateDesc}</td>
                    <td className={index % 2 ? 
                      "table__row table__row--alternate": 
                      "table__row"}>
                    {eachCatt.matchdevices[0].deviceDesc}</td>
                  </tr>
                  {eachCatt.matchdevices.map((match, deviceindex)=>{
                    if(deviceindex === 0)
                      return '';
                    return(<React.Fragment>
                      <tr>
                        <td className={ index % 2 ? 
                          "table__row table__row--alternate": "table__row"}>
                        {match.deviceDesc}</td>
                      </tr>
                    </React.Fragment>);
                  })}
                </React.Fragment>);
              })}
            </React.Fragment>);
          })}
          </tbody>
        </table>
        </React.Fragment>
      );
    }

    function assignmentSummaryTable(){
      if( checkArr.length > 0 ){
        let searchedDevices = [];
      if( searchFilter !== '' ) {
        
        searchedDevices = checkArr.filter((u) => {
          let filterResult = false; 
          const searchText = searchFilter.toUpperCase();
        
          if(valueAssignTo === "units"){
            const unitDescription = u.unitDesc.toUpperCase();
            if( unitDescription.includes(searchText)) {
              filterResult = true;
            }
            else{
              filterResult = u.category.some((category)=>{
                let tempResult = false;
                const categoryDescription = category.cateDesc.toUpperCase();
                if(categoryDescription.includes(searchText)){
                  tempResult = true;
                }
                else{
                  tempResult = category.matchdevices.some((device)=>{
                    let tempResult2 = false;
                    const deviceDescription = device.deviceDesc.toUpperCase();
                    if(deviceDescription.includes(searchText)){
                      tempResult2 = true;
                    }
                    return tempResult2;
                  })
                }
                return tempResult;
              })
            }
          }
          else if(valueAssignTo === "users"){
            const userFirstName = u.firstName.toUpperCase();
            const userLastName = u.lastName.toUpperCase();
            if ( userFirstName.includes(searchText) || userLastName.includes(searchText) ) {
              filterResult = true;
            }
            else{
              filterResult = u.category.some((category)=>{
                let tempResult =false;
                const categoryDescription = category.cateDesc.toUpperCase();
                if(categoryDescription.includes(searchText)){
                  tempResult = true;
                }
                else{
                  tempResult = category.matchdevices.some((device)=>{
                    let tempResult2 = false;
                    const deviceDescription = device.deviceDesc.toUpperCase();
                    if(deviceDescription.includes(searchText)){
                      tempResult2 = true;
                    }
                    return tempResult2;
                  })
                }
                return tempResult;
              })
            }
          } 
          return filterResult;
        });
      } else {
        searchedDevices = checkArr;
      }
      if(searchedDevices.length !== pagerParams.totalLength) {
        const pagerValues = { ...pagerParams };
        let startTemp = currentPage * pagerParams.incrementValue;
        let endTemp = (startTemp + pagerParams.incrementValue > searchedDevices.length) ? 
          searchedDevices.length : startTemp + pagerParams.incrementValue;
        pagerValues.totalLength = searchedDevices.length;
        pagerValues.startValue = startTemp;
        pagerValues.endValue = endTemp;
        pagerValues.totalPages = Math.ceil(searchedDevices.length/pagerParams.incrementValue);
        setPagerParams(pagerValues);
      }
    
      let sortedDevices;
      if( tableSort.sortParam === "unitDesc" || 
        tableSort.sortParam === "lastName" || 
        tableSort.sortParam === "firstName"){
        sortedDevices = dataSort(searchedDevices);
      }
      else if( tableSort.sortParam === "cateDesc"){
        sortedDevices = dataCategorySort(searchedDevices);
      }
      else if( tableSort.sortParam === "deviceDesc"){
        sortedDevices = dataDeviceSort(searchedDevices);
      }
      
      let pagedDevices = sortedDevices.slice(pagerParams.startValue,pagerParams.endValue);

      return(
        <React.Fragment>
          <InlineHelpText
            ref={checkBoxHelpTextRef}
            toggleFunction={toggleCheckBoxHelpText}
            message={checkBoxHelpText}/>
          <p></p>
            { conflictingDevicesArr.length === 0 ? "" : (
              <div className="width-100">
              <p className="text-medium alertText center-text">
              {"Check conflicts tab for Conflicting Assignments"}</p>
              </div>)}
          <div className="flex-spread width-100">
            <div className="center-self">
              <input type="textbox" 
                data-test="searchBox"
                className="message-table__filter-search-box search_bg"
                onChange={handleSearchFilter}
                value={searchFilter}/>
            </div>
            <div className="width-15">
              <Button
                onClick={() => handleAssign()}
                text={"Assign"}
                buttonType={buttonTypes.secondary}
                buttonSize={buttonSizes.extraSmall}
                buttonTextSize={buttonTextSizes.mediumSmall}
                additionalStyles="no-margin width-100 justify-center"
                disabled={ !anyChecked()}/>
            </div>
            {pagerParams.totalLength > 0 ? (
            <div className="react-paginate " data-test="react-paginate">
              <ReactPaginate previousLabel={'Prev'}
                nextLabel={'Next'}
                breakLabel={'...'}
                pageCount={pagerParams.totalPages}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                onPageChange={handlePageChange}
                activeClassName={'active'}
              forcePage={currentPage}
              />
            </div>) : ('')}
        </div>
        <p></p>
        {valueAssignTo === "units" ? 
        (displayUnitsTable(pagedDevices)): (displayUsersTable(pagedDevices))}
        <div className="container_2-column margin-top-10">
        {pagerParams.totalLength > 0 ? 
        (<div className="text-large placeend">
          <strong>{pagerParams.startValue+1}</strong> - 
          <strong>{pagerParams.endValue}</strong> of 
          <strong>{pagerParams.totalLength}</strong></div>):('')}
        {pagerParams.totalLength > 0 ? (
        <div className="react-paginate placeend" data-test="react-paginate">
          <ReactPaginate previousLabel={'Prev'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={pagerParams.totalPages}
            marginPagesDisplayed={1}
            pageRangeDisplayed={2}
            onPageChange={handlePageChange}
            activeClassName={'active'}
          forcePage={currentPage}
          />
        </div>) : ('')}
        </div>
        </React.Fragment>);
      }
      else{
        return(
        <div className="width-100">
            { conflictingDevicesArr.length === 0 ? (
            <p className="text-medium item-container__main-text center-text">
              {"No available assignments found"}</p>) :
             (<p className="text-medium alertText center-text">
               {"Check conflicts tab for Conflicting Assignments"}</p>)
            }
        </div>);
      }  
    }

    function displayTable() {
      if( view === "summary" && apiSpinner.assignmentSummaryReturned) {
        if( !assignmentTriggered ){
          return assignmentSummaryTable();}
        else {
          if( apiSpinner.deviceAssignmentReturned ){
            if( postConflict.length === 0){
              return(
                <div className="width-100">
                  <p className="text-medium item-container__main-text center-text">
                    {"Devices Assigned successfully"}</p>
                </div>);
            }
            else{
              if(valueAssignTo === 'units'){
                return displayUnitPostConflict();
              }
              else if(valueAssignTo === 'users'){
                return displayUserPostConflict();
              }
            }
          }
          else{
            return (
              <div className="loading-spinner__user-list-container">
                <LoadingSpinner />
              </div>
            );
          }
        }
      }
      else if(view === "unmatched" && apiSpinner.unmatchedDevicesReturned){ 
        return unMatchedDevices();
      }
      else if(view === "conflicts" && apiSpinner.assignmentSummaryReturned){ 
        return conflictingDevices();
      }
      else {
        return (
          <div className="loading-spinner__user-list-container">
            <LoadingSpinner />
          </div>
        );
      }
    }

    return(
    <div className="overlay__background">
    <div className="overlay__container radius-5">
    <div className="margin-10">
      <div className="close-window-icon-container">
        <div className="close-window-icon-button no-margin">
          <SvgXIcon onClick={onClose} data-test="close-icon-function" />
        </div>
      </div>
      <div className="justify-center width-100">   
        <h1 className="no-margin" data-test="display-title">Assignment Summary</h1></div>
        <p></p>
        <div className="tab-bar" data-test="tab-bar">
        <Button
          onClick={() => setView("summary")}
          text={"Summary"}
          buttonType={buttonTypes.noButton}
          buttonSize={buttonSizes.small}
          data-test="tab-button"
          buttonStyle={
            view === 'summary'
            ? 'text-medium tab-bar__tab tab-bar__tab--active'
            : 'text-medium  tab-bar__tab'
          }/>  
        <Button
          onClick={() => setView("unmatched")}
          text={"UnMatched Devices"}
          buttonType={buttonTypes.noButton}
          buttonSize={buttonSizes.small}
          data-test="tab-button"
          buttonStyle={
            view === 'unmatched'
            ? 'text-medium tab-bar__tab tab-bar__tab--active'
            : 'text-medium  tab-bar__tab'
          }/>
        { valueAssignTo === "users" ? (
          <Button
            onClick={() => setView("conflicts")}
            text={"Conflicts"}
            buttonType={buttonTypes.noButton}
            buttonSize={buttonSizes.small}
            data-test="tab-button"
            buttonStyle={
              view === 'conflicts'
              ? 'text-medium tab-bar__tab tab-bar__tab--active'
              : 'text-medium  tab-bar__tab'
            }/>
          ):""}
        </div>
        {displayTable()}  
      </div>
      </div>
    </div>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
      unMatched: state.assignDevices.unmatchedDevices,
      alarmDeviceTypes: state.assignDevices.categoryList,
      summary: state.assignDevices.summary,
      apiSpinner: state.ui.apiSpinner,
      postConflict: state.assignDevices.postConflictDevices,
      postConflictUserConflict: state.assignDevices.postConflictUserConflictDevices
    };
};

export default connect(mapStateToProps)(UnConnectedSuggestion);